module.exports = __webpack_public_path__ + "static/media/Z3.53e90c78.jpg";